"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  carbonCalculator: {
    title: '碳排放计算器',
    line: '航线',
    volume: '货物数量',
    unit: '单位',
    tips_1: '声明：',
    tips_2: 'SITC 致力于减少碳排放, 我们开发了以下炭排放计算器，以便各位尊敬的客户能够更加方便的随时掌握碳排放情况，进而帮助客户实现尽可能低的碳足迹目标。',
    tips_3: '以上碳排放计算器以公司实际营运船舶的动态数据为依据，数值可能会因船舶实际运行海况、工况等因素影响与实际值有所偏差，本公司不承担因引用该计算结果而产生的任何法律责任。如果您发现存在任何违规行为或对计算有疑问，请与我们联系。',
    result: '查询结果',
    distance: '距离(KM)',
    carbonNum: '碳排放量(KG)',
    serviceLineIdIsNull: '航线不为空',
    volumeIsNull: '数量不为空',
    unitIsNull: '单位不为空'
  },
  button: {
    search: '查询',
    reset: '重置'
  }
};